module.exports = __webpack_public_path__ + "img/allerton_b2.a4040ace.jpg";